import React, { useState, useEffect } from 'react'; 
import EmployeeAttendanceCalendar from '../../../components/MyAttendance';
import { Loader } from '../../../components/loade';

const EmployeeAttendance = () => {
    const [isLoading, setIsLoading] = useState(false);
    const userId = localStorage.getItem('userId');

    useEffect(() => {
        setIsLoading(true);

        setTimeout(() => {
            setIsLoading(false);
        }, 1000);
    }, []); 

    return (
        <div>
            {isLoading && <Loader />}
              
                <EmployeeAttendanceCalendar userId={userId} />
            
        </div>
    );
};

export default EmployeeAttendance;